import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Check} from '@wix/wix-ui-icons-common'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import {useMobileFontOverrides} from '../../../../../../commons/hooks/use-mobile-font-overrides'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {StepProps} from './interfaces'
import s from './step.scss'

export const Step: React.FC<StepProps> = ({
  stepKey,
  title,
  index,
  editing,
  completed,
  indexVisible,
  dividerVisible,
  renderStep,
  onEdit,
  t,
  scrollToElement,
}) => {
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()
  const disabled = !editing && !completed
  const collapsed = completed && !editing
  const editAction = () => onEdit(stepKey)
  const stepRef = useRef<HTMLDivElement>(null)
  const {experiments} = useExperiments()
  const newPolicyFontColorEnabled = experiments.enabled(ExperimentNames.NewPolicyFontColor)

  useEffect(() => {
    if (editing && stepKey !== FormStep.BuyerDetails) {
      setTimeout(() => {
        scrollToElement(stepKey)
      }, 10)
    }
  }, [editing, stepKey])

  return (
    <div
      ref={stepRef}
      data-hook={DH.CHECKOUT_STEP(stepKey)}
      id={stepKey}
      className={classNames(s.container, {[s.opened]: editing, [s.disabled]: disabled})}
    >
      {dividerVisible && <div className={classNames(s.divider, c.formTitleColor)} />}
      <div className={s.content}>
        <div className={classNames(s.row, s.titleContainer, c.formTitleFont, c.formTitleColor)}>
          <div
            data-hook={DH.CHECKOUT_STEP_TITLE}
            className={classNames(s.title, s.row, {[s.mobileFontSize]: mobileFontOverridesEnabled})}
          >
            {(indexVisible || collapsed) && (
              <div className={s.titleLeft}>{collapsed ? <Check size="1.5em" className={s.check} /> : `${index}.`}</div>
            )}
            <div>{title}</div>
          </div>
          {collapsed && (
            <div
              data-hook={DH.CHECKOUT_STEP_EDIT}
              className={classNames(s.edit, newPolicyFontColorEnabled ? c.linksColor : '')}
              onClick={editAction}
              onKeyDown={handleKeyPressEnterOrSpace(editAction)}
              tabIndex={0}
            >
              {t('mobile.checkout.edit')}
            </div>
          )}
        </div>
        {!disabled && renderStep(editing)}
      </div>
    </div>
  )
}
